import script from "./ErrorMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&setup=true&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=5dba8b26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dba8b26"]])

export default __exports__